import {
  FC,
  useEffect,
  useState,
  useMemo,
  useContext,
  useLayoutEffect,
  useRef,
  useCallback,
} from "react";
import { FiUsers } from "react-icons/fi";
import "./LeftSideMenu.scss";
import { useTranslation } from "react-i18next";
import { RiAdminLine } from "react-icons/ri";
import Link from "../../CustomComponent/Link/Link";

import { RootState } from "../../redux/rootReducers";
import { useDispatch, useSelector } from "react-redux";
import { lang } from "./../../models/index";
import Edfapaywhit from "./../../assets/images/FigmEdfapay.svg";
import HeadSetCustomerService from "./../../assets/images/head-set-phones-customer-service.svg";
import ThemeContext from "../../ThemeContext";
import useGetwidth from "../../CustomHooks/useGetWidth";
import {
  BranchIcon,
  DashBoardIcon,
  DashBoardMainIcon,
  LogoutIcon,
  ReconciliationIcon,
  TerminalIcon,
  TransactionIcon,
  UsersIcon,
} from "../Icons/LeftSideNavBarIcons";
import { logout } from "../../redux/actions/auth";
import { useNavigate } from "react-router-dom";
import {
  CustomersIcon,
  ListSquare,
  Partnericon,
  PaymentLogo,
  ProductIcon,
  RegisterationIcon,
  ReporticonWhite,
  RetailerIcon,
  // SendNotificationIcon,
  SettingsIcon,
} from "../Icons/CheckOutLogo";
//import { AiOutlineCustomerService } from "react-icons/ai";
import {
  detectBase64ImageType,
  getHomePage,
  handleLangugeDirection,
} from "../commonFunctions";
import CustomNav from "../CustomNav";
import { flattenArrayToObject } from "../../utils/helperFunctions";
import { isSftpEnabled } from "../../utils/envFlags";
import UIPLogo from "../../assets/images/UIPSideBarLogo.png";
interface Props {
  type: string;
  width: number;
  userId?: string;
}
interface projectType {
  HeadButton: any[];
  Link: any[];
}
interface MercahntItems {
  softPos: projectType;
  paymentGateway: projectType;
  invoicing: projectType;
}
interface menuLinks {
  admin: any[];
  partner: any[];
  merchant: MercahntItems;
}
const LeftSideMenu: FC<Props> = ({ width, type, userId }) => {
  const isUIBLogo = process.env.REACT_APP_USE_UIB_MENU_LOGO === "true";

  const role = useSelector((state: RootState) => state.authReducer.role);
  const authApi = useSelector((state: RootState) => state.authReducer);
  const merchantId: { merch_id: string; merchantData: any } = useSelector(
    (state: RootState) => state.merchantReducer,
  );

  const isPayByLinkEnabledForCurrentMerchant =
    merchantId?.merchantData?.payByLinkEnabled;
  const isRecurringEnabledForCurrentMerchant =
    merchantId?.merchantData?.recurringEnabled;

  const [active, setactiveLink] = useState("admin/merchantList");
  const [toggleMenuWidth, setToggleMenuWidth]: any = useState();
  const [mainMenuSizeState, setmainMenuSize]: any = useState(
    localStorage.getItem("collapse") || "200px",
  );
  const [hoverable, setHoverable] = useState(
    localStorage.getItem("hoverable") || null,
  );

  const themes = useContext(ThemeContext);
  const otpApi = useSelector((state: RootState) => state.otpReducer);

  const [activeGroup, setActiveGroup] = useState<string>(
    localStorage.getItem("proj") || "",
  );
  const { t } = useTranslation("translation", { keyPrefix: "mainMenu" });
  const { t: tGlobal } = useTranslation("translation");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  //const menuSide = document.getElementById('menu-side') as HTMLDivElement;
  const changeActiveLink = (linkName: string) => {
    setactiveLink(linkName);
  };
  const { width: screenWidth } = useGetwidth();
  const wrapperRef = useRef<any>(null);

  const homeNavigation = useMemo(() => {
    if (role === "admin") {
      return getHomePage(themes.projects).adminHomepage;
    } else if (role === "partner") {
      return getHomePage(themes.projects, authApi.partnerId).partnerHomePage;
    } else {
      return getHomePage(themes?.projects, merchantId.merch_id)
        .mercahntHomePage;
    }
  }, [role]);

  useEffect(() => {
    if (
      location.pathname.toLowerCase() == "/admin/merchantList".toLowerCase()
    ) {
      setactiveLink("admin/merchantList");
    } else if (
      location.pathname.toLowerCase().includes("SoftposDashboard".toLowerCase())
    ) {
      setactiveLink("PaymentGatewayDashboard");
    } else if (
      location.pathname
        .toLowerCase()
        .includes("PaymentGatewayDashboard".toLowerCase())
    ) {
      setactiveLink("PaymentGatewayDashboard");
    } else if (
      location.pathname.toLowerCase().includes("ThreatsDashboard".toLowerCase())
    ) {
      setactiveLink("ThreatsDashboard");
    } else if (
      location.pathname
        .toLowerCase()
        .includes("admin/PartnersReports".toLowerCase())
    ) {
      setactiveLink("admin/PartnersReports");
    } else if (location.pathname.toLowerCase() == "/DashBoard".toLowerCase()) {
      setactiveLink("DashBoard");
    } else if (
      location.pathname.toLowerCase() ===
      `/merchant/${merchantId.merch_id}`.toLowerCase()
    ) {
      setactiveLink("home");
    } else if (
      location.pathname.toLowerCase().includes("/userManagement".toLowerCase())
    ) {
      setactiveLink("userManagement");
    } else if (
      location.pathname.toLowerCase().includes("/paymentMethods".toLowerCase())
    ) {
      setactiveLink("paymentMethods");
    } else if (location.pathname.toLowerCase() == "/reports".toLowerCase()) {
      setactiveLink("reports");
    } else if (location.pathname.toLowerCase() == "/Invoice".toLowerCase()) {
      setactiveLink("Invoice");
    } else if (location.pathname.toLowerCase() == "/branches".toLowerCase()) {
      setactiveLink("branches");
    } else if (
      location.pathname.toLowerCase().includes("/users".toLowerCase())
    ) {
      setactiveLink("users");
    } else if (location.pathname.toLowerCase() == "/terminals".toLowerCase()) {
      setactiveLink("terminals");
    } else if (
      location.pathname
        .toLowerCase()
        .includes("transactions/transactionsHistory".toLowerCase())
    ) {
      setactiveLink("transactions");
    } else if (
      location.pathname.toLowerCase() == "Edfapay/Reciept".toLowerCase() ||
      location.pathname.toLowerCase() == "transactions/Reciept".toLowerCase()
    ) {
      setactiveLink("transactions");
    } else if (
      location.pathname.toLowerCase() == "/Invoice/dashboard".toLowerCase()
    ) {
      setactiveLink("Invoice-dashboard");
    } else if (
      location.pathname.toLowerCase().includes("createInvoice".toLowerCase())
    ) {
      setactiveLink("createInvoice");
    } else if (
      location.pathname.toLowerCase().includes("InvoiceList".toLowerCase()) ||
      location.pathname.toLowerCase().includes("Invoice".toLowerCase())
    ) {
      setactiveLink("InvoiceList");
    } else if (
      location.pathname.toLowerCase().includes("setting".toLowerCase())
    ) {
      setactiveLink("globalSetting");
    } else if (
      location.pathname
        .toLowerCase()
        .includes("/reconciliationHistory".toLowerCase())
    ) {
      setactiveLink("reconciliationHistory");
    } else if (
      location.pathname.toLowerCase().includes("/sftp".toLowerCase())
    ) {
      setactiveLink("sftp");
    } else if (location.pathname.toLowerCase() == "/merchant/".toLowerCase()) {
      setactiveLink("merchant");
    } else if (
      location.pathname
        .toLowerCase()
        .includes("/paymentGateway/transactions".toLowerCase())
    ) {
      setactiveLink("paymentTransactions");
    } else if (
      location.pathname
        .toLowerCase()
        .includes("/paymentGateway/Dashboard".toLowerCase())
    ) {
      setactiveLink("paymentDashboard");
    } else if (
      location.pathname.toLowerCase().includes("/allReports".toLowerCase())
    ) {
      setactiveLink("allReports");
    } else if (
      location.pathname.toLowerCase().includes("/configuration".toLowerCase())
    ) {
      setactiveLink("configuration");
    } else if (
      location.pathname.toLowerCase().includes("/adminReports".toLowerCase())
    ) {
      setactiveLink("adminReports");
    } else if (
      location.pathname.toLowerCase().includes("/notifications".toLowerCase())
    ) {
      setactiveLink("notifications");
    } else if (
      location.pathname.toLowerCase().includes("/merchants".toLowerCase())
    ) {
      setactiveLink("merchants");
    } else if (
      location.pathname.toLowerCase().includes("/partners".toLowerCase())
    ) {
      setactiveLink("partners");
    } else if (
      location.pathname.toLowerCase().includes("/customers".toLowerCase())
    ) {
      setactiveLink("Customers");
    } else if (
      location.pathname.toLowerCase().includes("/allDashboard".toLowerCase())
    ) {
      setactiveLink("Customers");
    } else if (location.pathname.toLowerCase() === "usersList".toLowerCase()) {
      setactiveLink("usersList");
    } else if (
      location.pathname
        .toLowerCase()
        .includes("/productManagement".toLowerCase())
    ) {
      setactiveLink("productManagement");
    } else if (
      location.pathname
        .toLowerCase()
        .includes("/onlineRegisteration".toLowerCase())
    ) {
      setactiveLink("onlineRegisteration");
    } else if (
      location.pathname.toLowerCase().includes("admin/recurring".toLowerCase())
    ) {
      setactiveLink("recurringPayment");
    } else if (
      location.pathname
        .toLowerCase()
        .includes("/partner/recurring".toLowerCase())
    ) {
      setactiveLink("recurringPayment");
    } else if (
      location.pathname
        .toLowerCase()
        .includes(
          `merchant/${merchantId?.merch_id}/recurring/reminder-distribute`.toLowerCase(),
        )
    ) {
      setactiveLink("reminderDistribute");
    } else if (
      location.pathname
        .toLowerCase()
        .includes(
          `merchant/${merchantId?.merch_id}/recurring/assigned-plans`.toLowerCase(),
        )
    ) {
      setactiveLink("assignedPlans");
    } else if (
      location.pathname
        .toLowerCase()
        .includes(`merchant/${merchantId?.merch_id}/recurring`.toLowerCase())
    ) {
      setactiveLink("recurringPayment");
    } else if (
      location.pathname.includes("/merchant/recurring/recurringPlan/")
    ) {
      setactiveLink("InvoiceList");
    } else if (
      location.pathname.toLowerCase().includes("/admin/access") ||
      location.pathname.includes(
        `/merchant/${merchantId?.merch_id}/access`.toLowerCase(),
      ) ||
      (location.pathname.toLowerCase().includes("/partner/") &&
        location.pathname.toLowerCase().includes("/access"))
    ) {
      setactiveLink("accessApi");
    } else if (
      location.pathname.includes(
        `/merchant/${merchantId?.merch_id}/secret`.toLowerCase(),
      )
    ) {
      setactiveLink("merchantSecret");
    } else if (location.pathname.includes("tickets")) {
      setactiveLink("tickets");
    }

    setActiveGroup(localStorage.getItem("proj") || "");
  }, [location.pathname]);

  const marginChange = (value: string) => {
    const rightSide = document.getElementsByClassName(
      "content-side",
    ) as HTMLCollectionOf<HTMLElement>;
    const Arrow = document.getElementsByClassName(
      "Arrow",
    ) as HTMLCollectionOf<HTMLElement>;
    const menuTopBar = document.getElementById(
      "navbar-elements",
    ) as HTMLDivElement;
    const handlestyleDirection = (margin: any, direction: any) => {
      rightSide[0].style[margin] = value;
      menuTopBar.style[direction] = value;
    };
    handleLangugeDirection(lang, "marginChange", handlestyleDirection);
    //const linkElement = document.getElementsByClassName("link-element") as HTMLCollectionOf<HTMLElement>;
    /* if (lang === "en" ||lang === "fr") {
      rightSide[0].style.marginLeft = value;
      menuTopBar.style.left = value;
    }
    else {
      rightSide[0].style.marginRight = value;
      menuTopBar.style.right = value;
    }
 */
    if (localStorage.getItem("collapse") === "90px") {
      for (let j = 0; j < Arrow.length; j++) {
        Arrow[j].style.display = "none";
        Arrow[j].style.display = "none";
      }
    } else {
      for (let j = 0; j < Arrow.length; j++) {
        Arrow[j].style.display = "inline-block";
      }
    }
  };

  useLayoutEffect(() => {
    const menuSide = document.getElementById("menu-side") as HTMLDivElement;
    if (screenWidth > 700) {
      if (mainMenuSizeState === "200px") {
        marginChange?.("200px");
      } else {
        marginChange?.("90px");
      }
    } else if (screenWidth < 700) {
      menuSide.style.display = "none";
      marginChange?.("0px");
      if (mainMenuSizeState === "200px") {
        marginChange?.("0px");
      } else {
        marginChange?.("0px");
      }
    }
  }, [toggleMenuWidth, screenWidth]);

  const changeActiveGroup = (active: string) => {
    if (active === activeGroup) {
      setActiveGroup(active);
    } else {
      setActiveGroup(active);
      localStorage.setItem("proj", active);
    }
  };

  const HandleMouseOnOut = (type: number) => {
    //0 meanse he is out
    var hoverable = localStorage.getItem("hoverable");
    if (screenWidth > 700) {
      if (type == 0 && hoverable) {
        setToggleMenuWidth(false);
        localStorage.setItem("collapse", "90px");
        setmainMenuSize(localStorage.getItem("collapse"));
      } else {
        setToggleMenuWidth(true);
        localStorage.setItem("collapse", "200px");
        setmainMenuSize(localStorage.getItem("collapse"));
      }
    } else {
      setToggleMenuWidth(true);
      localStorage.setItem("collapse", "200px");
      setmainMenuSize(localStorage.getItem("collapse"));
    }
  };

  const handleClickOutside = (event: any) => {
    const menuSide = document.getElementById("menu-side") as HTMLDivElement;
    if (
      wrapperRef.current &&
      !wrapperRef.current.contains(event.target) &&
      screenWidth < 700
    ) {
      menuSide.style.display = "none";
    }
  };

  const Logout = () => {
    dispatch(logout(authApi.token, authApi.refreshToken));
    navigate("/login");
  };

  useEffect(() => {
    const menuSide = document.getElementById("menu-side") as HTMLDivElement;
    if (screenWidth < 700) {
      document.addEventListener("click", handleClickOutside, true);
      HandleMouseOnOut(1);
    } else {
      menuSide.style.display = "block";
      HandleMouseOnOut(0);
    }
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, [screenWidth]);

  const toggleMainMenu = () => {
    var hoverable = localStorage.getItem("hoverable");
    if (screenWidth > 700) {
      if (hoverable) {
        localStorage.removeItem("hoverable");
        setHoverable(null);
        HandleMouseOnOut(1);
      } else {
        localStorage.setItem("hoverable", "true");
        setHoverable("true");
        HandleMouseOnOut(0);
      }
    } else {
      HandleMouseOnOut(0);
      const menuSide = document.getElementById("menu-side") as HTMLDivElement;
      menuSide.style.display = "block";
    }
  };

  const customNav = useMemo(() => {
    return (
      <CustomNav
        role={authApi.role}
        otpStatus="success"
        toggleMainMenu={toggleMainMenu}
        toggleMenuWidth={toggleMenuWidth}
      />
    );
  }, [toggleMenuWidth]);

  const handleGetTransactionLink = useMemo(() => {
    if (themes?.countryCode != "TN") {
      return "CardApplepay";
    } else {
      return "ClicToPay";
    }
  }, []);

  const otpPartnerId =
    otpApi.data?.partnerBranding?.partnerId ?? otpApi.data?.partner?.partnerId;

  const loggedInPartner =
    themes?.partners?.find(
      (partner: any) => partner?.partnerId === authApi?.partnerId,
    ) ??
    themes?.partners?.find(
      (partner: any) => partner.partnerId === otpPartnerId,
    );

  const projects = useMemo(() => {
    if (loggedInPartner?.projects) {
      return flattenArrayToObject(loggedInPartner.projects, "name", "enabled");
    }
    return themes?.projects || {};
  }, [authApi.role, loggedInPartner, themes?.projects]);

  return (
    <>
      {customNav}
      <div className="menu-container shadow" ref={wrapperRef}>
        <div className="menu-side " id="menu-side">
          <div
            className="left-sideMenu"
            id="left-sideMenu"
            onMouseEnter={() => {
              HandleMouseOnOut(1);
            }}
            onMouseLeave={() => {
              HandleMouseOnOut(0);
            }}
          >
            <div
              className={`Link-Container`}
              style={{ width: `${mainMenuSizeState}` }}
            >
              <Link to={homeNavigation} type={"link"} className="branding">
                {themes?.name != "Edfapay" ? (
                  <>
                    {isUIBLogo ? (
                      <img src={UIPLogo} alt="UIB Logo" />
                    ) : (
                      <img
                        className="monty-pay"
                        src={
                          mainMenuSizeState === "200px"
                            ? detectBase64ImageType(themes?.loginPagelogo)
                            : detectBase64ImageType(themes?.smallLogo)
                        }
                      />
                    )}
                  </>
                ) : (
                  <>
                    {mainMenuSizeState === "200px" ? (
                      <object
                        data={Edfapaywhit}
                        height="30"
                        color="rgb(00 230 160)"
                      ></object>
                    ) : (
                      <img
                        src={detectBase64ImageType(themes?.smallLogo)}
                        style={{
                          width: "100px",
                          height: "60px",
                          margin: "-20px",
                        }}
                      />
                    )}
                  </>
                )}
              </Link>
              <div className="navbar-main-elements">
                {type === "admin" && authApi.role === "admin" ? (
                  <>
                    <Link
                      to={getHomePage(projects).adminHomepage}
                      type={"link"}
                      active={"PaymentGatewayDashboard"}
                      onclick={changeActiveLink}
                      classname={`link-element  ${
                        active === "PaymentGatewayDashboard" && `active `
                      } `}
                    >
                      <span className="span-svg">
                        <DashBoardMainIcon />
                      </span>
                      {mainMenuSizeState === "200px" ? (
                        <span className="report-type">
                          {" "}
                          {t("main.Dashboard")}{" "}
                        </span>
                      ) : null}
                    </Link>

                    {/* <Link
                      to="/admin/ThreatsDashboard"
                      type={"link"}
                      active={"ThreatsDashboard"}
                      onclick={changeActiveLink}
                      classname={`link-element  ${active === "ThreatsDashboard" && `active `
                        } `}
                    >
                      <span className="span-svg">

                        <DashBoardMainIcon />
                      </span>
                      {mainMenuSizeState === "200px" ? (
                        <span className="report-type"> {t("main.ThreatsDashboard")} </span>
                      ) : null}
                    </Link> */}
                    <Link
                      to="/admin/merchantList"
                      type={"link"}
                      active={"admin/merchantList"}
                      onclick={changeActiveLink}
                      classname={`link-element  ${
                        active === "admin/merchantList" && `active `
                      } `}
                    >
                      <span className="span-svg">
                        <RiAdminLine />
                      </span>
                      {mainMenuSizeState === "200px" ? (
                        <span className="report-type"> {t("main.admin")} </span>
                      ) : null}
                    </Link>
                    <Link
                      to="/admin/PartnersReports"
                      type={"link"}
                      active={"admin/PartnersReports"}
                      onclick={changeActiveLink}
                      classname={`link-element  ${
                        active === "admin/PartnersReports" && `active `
                      } `}
                    >
                      <span className="span-svg">
                        <Partnericon color={"#ffffff"} />
                      </span>
                      {mainMenuSizeState === "200px" ? (
                        <span className="report-type">
                          {" "}
                          {t("main.partners")}{" "}
                        </span>
                      ) : null}
                    </Link>

                    {/*  <Link
                      to="/admin/merchants"
                      type={"link"}
                      active={"merchants"}
                      onclick={changeActiveLink}
                      classname={`link-element  ${active === "merchants" && `active `
                        } `}
                    >
                      <span className="span-svg">
                        <MerchantIcon />
                      </span>
                      {mainMenuSizeState === "200px" ? (
                        <span className="report-type">
                          {t("main.merchants")}
                        </span>
                      ) : null}
                    </Link>
                    <Link
                      to="/admin/partners"
                      type={"link"}
                      active={"partners"}
                      onclick={changeActiveLink}
                      classname={`link-element  ${active === "partners" && `active `
                        } `}
                    >
                      <span className="span-svg">
                        <PartnerIcon />
                      </span>
                      {mainMenuSizeState === "200px" ? (
                        <span className="report-type">
                          {t("main.partners")}
                        </span>
                      ) : null}
                    </Link> */}
                    <Link
                      to="/admin/allReports"
                      type={"link"}
                      active={"allReports"}
                      onclick={changeActiveLink}
                      classname={`link-element  ${
                        active === "allReports" && `active `
                      } `}
                    >
                      <span className="span-svg">
                        <ReporticonWhite />
                      </span>
                      {mainMenuSizeState === "200px" ? (
                        <span className="report-type">
                          {t("main.allReports")}
                        </span>
                      ) : null}
                    </Link>
                    <Link
                      to="/admin/onlineRegisteration"
                      type={"link"}
                      active={"onlineRegisteration"}
                      onclick={changeActiveLink}
                      classname={`link-element  ${
                        active === "onlineRegisteration" && `active `
                      } `}
                    >
                      <span className="span-svg">
                        <RegisterationIcon />
                      </span>
                      {mainMenuSizeState === "200px" ? (
                        <span className="report-type">
                          {
                            t(
                              "main.Registeration",
                            ) /* t("main.configuration") */
                          }
                        </span>
                      ) : null}
                    </Link>
                    <Link
                      to="/admin/paymentMethods"
                      type={"link"}
                      active={"paymentMethods"}
                      onclick={changeActiveLink}
                      classname={`link-element  ${
                        active === "paymentMethods" && `active `
                      } `}
                    >
                      <span className="span-svg">
                        <PaymentLogo />
                      </span>
                      {mainMenuSizeState === "200px" ? (
                        <span className="report-type">
                          {t("main.paymentMethods")}
                        </span>
                      ) : null}
                    </Link>

                    {/* <Link
                      to="/admin/notifications"
                      type={"link"}
                      active={"notifications"}
                      onclick={changeActiveLink}
                      classname={`link-element  ${active === "notifications" && `active `
                        } `}
                    >
                      <span className="span-svg">
                        <SendNotificationIcon />
                      </span>
                      {mainMenuSizeState === "200px" ? (
                        <span className="report-type">
                          {t("main.sendnotification")}
                        </span>
                      ) : null}
                    </Link> */}
                    <Link
                      to="/admin/configuration"
                      type={"link"}
                      active={"configuration"}
                      onclick={changeActiveLink}
                      classname={`link-element  ${
                        active === "configuration" && `active`
                      } `}
                    >
                      <span className="span-svg">
                        <SettingsIcon />
                      </span>
                      {mainMenuSizeState === "200px" ? (
                        <span className="report-type">
                          {t("main.configuration")}
                        </span>
                      ) : null}
                    </Link>

                    <Link
                      to="/admin/access"
                      type={"link"}
                      active={"accessApi"}
                      onclick={changeActiveLink}
                      classname={`link-element  ${
                        active === "accessApi" && `active `
                      } `}
                    >
                      <span className="span-svg">
                        <PaymentLogo />
                      </span>
                      {mainMenuSizeState === "200px" ? (
                        <span className="report-type">
                          {t("sub.accessApi")}
                        </span>
                      ) : null}
                    </Link>

                    <Link
                      to="/admin/adminReports"
                      type={"link"}
                      active={"adminReports"}
                      onclick={changeActiveLink}
                      classname={`link-element  ${
                        active === "adminReports" && `active `
                      } `}
                    >
                      <span className="span-svg">
                        <RetailerIcon />
                      </span>
                      {mainMenuSizeState === "200px" ? (
                        <span className="report-type">
                          {t("main.logReports")}
                        </span>
                      ) : null}
                    </Link>

                    <div className="softpos-container project">
                      <button
                        className={`collapse-button  ${
                          activeGroup === "recurringPayment"
                            ? "active-group"
                            : ""
                        } `}
                        onClick={() => changeActiveGroup("recurringPayment")}
                      >
                        <span>{t("main.recurringPayment").toUpperCase()}</span>
                      </button>
                      <div className="SoftPos-Link">
                        <Link
                          to="/admin/recurring"
                          type={"link"}
                          active={"recurringPayment"}
                          onclick={changeActiveLink}
                          classname={`link-element  ${
                            active === "recurringPayment" && `active `
                          } `}
                        >
                          <span className="span-svg">
                            <PaymentLogo />
                          </span>
                          {mainMenuSizeState === "200px" ? (
                            <span className="report-type">
                              {t("main.recurringPayment")}
                            </span>
                          ) : null}
                        </Link>
                      </div>
                    </div>
                    {projects?.customerSupport && (
                      <div className="softpos-container project">
                        <button
                          className={`collapse-button  ${
                            activeGroup === "contactUs" ? "active-group" : ""
                          } `}
                          onClick={() => changeActiveGroup("contactUs")}
                        >
                          <span>{t("main.contactUs").toUpperCase()}</span>
                        </button>
                        <div className="SoftPos-Link">
                          <Link
                            to={`/tickets`}
                            state={{ layoutType: "admin" }}
                            type={"link"}
                            active={"tickets"}
                            onclick={changeActiveLink}
                            classname={`link-element  ${
                              active === "tickets" && `active `
                            } `}
                          >
                            <span className="span-svg">
                              <object
                                data={HeadSetCustomerService}
                                height="30"
                                color="ffff"
                              ></object>
                            </span>
                            {mainMenuSizeState === "200px" ? (
                              <span className="report-type">
                                {t("sub.tickets")}
                              </span>
                            ) : null}
                          </Link>
                        </div>
                      </div>
                    )}
                  </>
                ) : type === "admin" ||
                  (type === "partner" && authApi.role === "partner") ? (
                  <>
                    <Link
                      to={
                        homeNavigation
                      } /* {`/partner/PaymentGatewayDashboard/${authApi.partnerId}`} */
                      type={"link"}
                      active={"PaymentGatewayDashboard"}
                      onclick={changeActiveLink}
                      classname={`link-element  ${
                        active === "PaymentGatewayDashboard" && `active `
                      } `}
                    >
                      <span className="span-svg">
                        <DashBoardMainIcon />
                      </span>
                      {mainMenuSizeState === "200px" ? (
                        <span className="report-type">
                          {" "}
                          {t("main.Dashboard")}{" "}
                        </span>
                      ) : null}
                    </Link>
                    <Link
                      to={`/partner/merchantList/${authApi.partnerId}`}
                      type={"link"}
                      active={"admin/merchantList"}
                      onclick={changeActiveLink}
                      classname={`link-element  ${
                        active === "admin/merchantList" && `active `
                      } `}
                    >
                      <span className="span-svg">
                        <RiAdminLine />
                      </span>
                      {mainMenuSizeState === "200px" ? (
                        <span className="report-type"> {t("main.admin")} </span>
                      ) : null}
                    </Link>
                    <Link
                      to={`/partner/allReports/${authApi.partnerId}`}
                      type={"link"}
                      active={"allReports"}
                      onclick={changeActiveLink}
                      classname={`link-element  ${
                        active === "allReports" && `active `
                      } `}
                    >
                      <span className="span-svg">
                        <ReporticonWhite />
                      </span>
                      {mainMenuSizeState === "200px" ? (
                        <span className="report-type">
                          {t("main.allReports")}
                        </span>
                      ) : null}
                    </Link>
                    {/*  <Link
                        to={`/partner/configuration/${authApi.partnerId}`}
                        type={"link"}
                        active={"configuration"}
                        onclick={changeActiveLink}
                        classname={`link-element  ${active === "configuration" && `active `
                          } `}
                      >
                        <span className="span-svg">
                          <SettingsIcon />
                        </span>
                        {mainMenuSizeState === "200px" ? (
                          <span className="report-type">
                            {t("main.configuration")}
                          </span>
                        ) : null}
                      </Link> */}
                    <Link
                      to={`/partner/onlineRegisteration/${authApi.partnerId}`}
                      type={"link"}
                      active={"onlineRegisteration"}
                      onclick={changeActiveLink}
                      classname={`link-element  ${
                        active === "onlineRegisteration" && `active `
                      } `}
                    >
                      <span className="span-svg">
                        <RegisterationIcon />
                      </span>
                      {mainMenuSizeState === "200px" ? (
                        <span className="report-type">
                          {
                            t(
                              "main.Registeration",
                            ) /* t("main.configuration") */
                          }
                        </span>
                      ) : null}
                    </Link>

                    {
                      <Link
                        to="/partner/recurring"
                        type={"link"}
                        className={`link-element ${
                          active === "recurringPayment" ? "active" : ""
                        }`}
                        onClick={() => setactiveLink("recurringPayment")}
                      >
                        <span className="span-svg">
                          <PaymentLogo />
                        </span>
                        {mainMenuSizeState === "200px" ? (
                          <span className="report-type">
                            {t("main.recurringPayment")}
                          </span>
                        ) : null}
                      </Link>

                      /* <Link
                      to="/merchant/recurring"
                      type={"link"}
                      className={`link-element ${
                        active === "recurringPayment" ? "active" : ""
                      }`}
                      onClick={() => setactiveLink("recurringPayment")}
                    >
                      <span className="span-svg">
                        <PaymentLogo />
                      </span>
                      {mainMenuSizeState === "200px" ? (
                        <span className="report-type">
                          {t("main.recurringPayment")}
                        </span>
                      ) : null}
                    </Link> */
                    }

                    <div className="softpos-container project">
                      <button
                        className={`collapse-button  ${
                          activeGroup === "accessApi" ? "active-group" : ""
                        } `}
                        onClick={() => changeActiveGroup("accessApi")}
                      >
                        <span>{t("sub.accessApi").toUpperCase()}</span>
                      </button>
                      <Link
                        to={`/partner/${authApi.partnerId}/access`}
                        type={"link"}
                        active={"accessApi"}
                        onclick={changeActiveLink}
                        classname={`link-element  ${
                          active === "accessApi" && `active`
                        } `}
                      >
                        <span className="span-svg">
                          <PaymentLogo />
                        </span>
                        {mainMenuSizeState === "200px" ? (
                          <span className="report-type">
                            {t("sub.accessApi")}
                          </span>
                        ) : null}
                      </Link>
                    </div>

                    {localStorage.getItem("isprimary") === "true" ? (
                      <Link
                        to={`../partner/usersList/${authApi.partnerId}`}
                        type={"link"}
                        className={`link-element ${
                          active === "usersList" ? "active" : ""
                        }`}
                        onClick={() => setactiveLink("usersList")}
                      >
                        <span className="span-svg">
                          <PaymentLogo />
                        </span>
                        {mainMenuSizeState === "200px" ? (
                          <span className="report-type">{t("main.users")}</span>
                        ) : null}
                      </Link>
                    ) : null}
                    {projects?.customerSupport && (
                      <div className="softpos-container project">
                        <button
                          className={`collapse-button  ${
                            activeGroup === "contactUs" ? "active-group" : ""
                          } `}
                          onClick={() => changeActiveGroup("contactUs")}
                        >
                          <span>{t("main.contactUs").toUpperCase()}</span>
                        </button>
                        <div className="SoftPos-Link">
                          <Link
                            to={`/tickets`}
                            state={{ layoutType: "partner" }}
                            type={"link"}
                            active={"tickets"}
                            onclick={changeActiveLink}
                            classname={`link-element  ${
                              active === "tickets" && `active `
                            } `}
                          >
                            <span className="span-svg">
                              <object
                                data={HeadSetCustomerService}
                                height="30"
                                color="rgb(0000)"
                              ></object>
                            </span>
                            {mainMenuSizeState === "200px" ? (
                              <span
                                className="report-type"
                                style={
                                  active === "tickets"
                                    ? { color: "var(--mainGreenColor)" }
                                    : undefined
                                }
                              >
                                {t("sub.tickets")}
                              </span>
                            ) : null}
                          </Link>
                        </div>
                      </div>
                    )}
                  </>
                ) : (
                  <>
                    {/* <div className="softpos-container project">
                          <button
                            className={`collapse-button  ${activeGroup === "allDashboard" ? "active-group" : ""
                              } `}
                            onClick={() => changeActiveGroup("allDashboard")}
                          >
                            <span> Dashboard </span>
                            {activeGroup === "allDashboard" ? (
                              <span className="Arrow">
                                <svg className="svg" viewBox="0 0 1024 1024">
                                  <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                                  <g
                                    id="SVGRepo_tracerCarrier"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  ></g>
                                  <g id="SVGRepo_iconCarrier">
                                    <path d="M759.2 419.8L697.4 358 512 543.4 326.6 358l-61.8 61.8L512 667z"></path>
                                  </g>
                                </svg>
                              </span>
                            ) : (
                              <span className="Arrow">
                                <svg className="svg" viewBox="0 0 1024 1024">
                                  <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                                  <g
                                    id="SVGRepo_tracerCarrier"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  ></g>
                                  <g id="SVGRepo_iconCarrier">
                                    <path d="M264.8 604.7l61.8 61.8L512 481.1l185.4 185.4 61.8-61.8L512 357.5z"></path>
                                  </g>
                                </svg>
                              </span>
                            )}
                          </button>
                          {activeGroup === "allDashboard" && themes.projects.invoicing ? (
                            <div className="SoftPos-Link">
                              <Link
                                to={`/merchant/${merchantId.merch_id}/allDashboard`}
                                type={"link"}
                                active={"allDashboard"}
                                onclick={changeActiveLink}
                                classname={`link-element ${active === "allDashboard" && `active `
                                  } `}
                              >
                                <span className="span-svg">
                                  <CustomersIcon
                                    color={
                                      active === "allDashboard"
                                        ? themes.MainGreenColorHexa
                                        : "white"
                                    }
                                  />
                                </span>
                                {mainMenuSizeState === "200px" ? (
                                  <span className="report-type">
                                    Dashboard

                                  </span>
                                ) : null}
                              </Link>
                            </div>
                          ) : (
                            <></>
                          )}
                        </div> */}
                    {(projects.softPos || authApi.role === "admin") && (
                      <div className="softpos-container project">
                        <button
                          className={`collapse-button  ${
                            activeGroup === "softpos" ? "active-group" : ""
                          } `}
                          onClick={() => changeActiveGroup("softpos")}
                        >
                          <span> {t("main.softPos").toUpperCase()}</span>
                        </button>

                        <div className="SoftPos-Link">
                          <Link
                            to={`/merchant/${merchantId?.merch_id}`}
                            type={"link"}
                            active={"home"}
                            onclick={changeActiveLink}
                            classname={`link-element   ${
                              active === "home" && `active`
                            }`}
                          >
                            <span className="span-svg">
                              <DashBoardIcon />
                            </span>
                            {mainMenuSizeState === "200px" ? (
                              <span className="report-type">
                                {t("sub.dashboard")}
                              </span>
                            ) : null}
                          </Link>

                          <Link
                            to="/branches"
                            type={"link"}
                            active={"branches"}
                            onclick={changeActiveLink}
                            classname={`link-element  ${
                              active === "branches" && `active `
                            } `}
                          >
                            <span className="span-svg">
                              <BranchIcon />
                            </span>
                            {mainMenuSizeState === "200px" ? (
                              <span className="report-type">
                                {t("sub.branches")}
                              </span>
                            ) : null}
                          </Link>
                          <Link
                            to={`/merchant/${merchantId.merch_id}/users`}
                            type={"link"}
                            active={"users"}
                            onclick={changeActiveLink}
                            classname={`link-element  ${
                              active === "users" && `active `
                            } `}
                          >
                            <span className="span-svg">
                              <UsersIcon />
                            </span>
                            {mainMenuSizeState === "200px" ? (
                              <span className="report-type">
                                {t("sub.users")}
                              </span>
                            ) : null}
                          </Link>
                          <Link
                            to="/terminals"
                            type={"link"}
                            active={"terminals"}
                            onclick={changeActiveLink}
                            classname={`link-element  ${
                              active === "terminals" && `active `
                            } `}
                          >
                            <span className="span-svg">
                              <TerminalIcon />
                            </span>
                            {mainMenuSizeState === "200px" ? (
                              <span className="report-type">
                                {t("sub.terminals")}
                              </span>
                            ) : null}
                          </Link>
                          <Link
                            to="/transactions/transactionsHistory"
                            type={"link"}
                            active={"transactions"}
                            onclick={changeActiveLink}
                            classname={`link-element  ${
                              active === "transactions" && `active `
                            } `}
                          >
                            <span className="span-svg">
                              <TransactionIcon />
                            </span>
                            {mainMenuSizeState === "200px" ? (
                              <span className="report-type">
                                {t("sub.Transactions")}
                              </span>
                            ) : null}
                          </Link>
                          <Link
                            to="/reconciliation/reconciliationHistory"
                            type={"link"}
                            active={"reconciliationHistory"}
                            onclick={changeActiveLink}
                            classname={`link-element  ${
                              active === "reconciliationHistory" && `active `
                            } `}
                          >
                            <span className="span-svg">
                              <ReconciliationIcon />
                            </span>
                            {mainMenuSizeState === "200px" ? (
                              <span className="report-type">
                                {t("sub.Reconcileation")}
                              </span>
                            ) : null}
                          </Link>
                          {isUIBLogo && isSftpEnabled() && (
                            <Link
                              to="/sftp"
                              type={"link"}
                              active={"sftp"}
                              onclick={changeActiveLink}
                              classname={`link-element  ${
                                active === "sftp" && `active `
                              } `}
                            >
                              <span className="span-svg">
                                <ListSquare />
                              </span>
                              {mainMenuSizeState === "200px" ? (
                                <span className="report-type">SFTP</span>
                              ) : null}
                            </Link>
                          )}
                        </div>
                      </div>
                    )}
                    {(projects.recurringPayment ||
                      authApi.role === "admin") && (
                      <div className="softpos-container project">
                        <button
                          className={`collapse-button  ${
                            activeGroup === "recurringPayment"
                              ? "active-group"
                              : ""
                          } `}
                          onClick={() => changeActiveGroup("recurringPayment")}
                        >
                          <span>
                            {t("main.recurringPayment").toUpperCase()}
                          </span>
                        </button>
                        <div className="SoftPos-Link">
                          <Link
                            to={`/merchant/${merchantId?.merch_id}/recurring`}
                            type={"link"}
                            active={"recurringPayment"}
                            onclick={changeActiveLink}
                            classname={`link-element  ${
                              active === "recurringPayment" && `active `
                            } `}
                          >
                            <span className="span-svg">
                              <PaymentLogo />
                            </span>
                            {mainMenuSizeState === "200px" ? (
                              <span className="report-type">
                                {t("main.recurringPayment")}
                              </span>
                            ) : null}
                          </Link>
                          <Link
                            to={`/merchant/${merchantId?.merch_id}/recurring/assigned-plans`}
                            type={"link"}
                            active={"assignedPlans"}
                            onclick={changeActiveLink}
                            classname={`link-element  ${
                              active === "assignedPlans" && `active `
                            } `}
                          >
                            <span className="span-svg">
                              <PaymentLogo />
                            </span>
                            {mainMenuSizeState === "200px" ? (
                              <span className="report-type">
                                {t("main.assignedPlans")}
                              </span>
                            ) : null}
                          </Link>
                          <Link
                            to={`/merchant/${merchantId?.merch_id}/recurring/reminder-distribute`}
                            type={"link"}
                            active={"reminderDistribute"}
                            onclick={changeActiveLink}
                            classname={`link-element  ${
                              active === "reminderDistribute" && `active `
                            } `}
                          >
                            <span className="span-svg">
                              <PaymentLogo />
                            </span>
                            {mainMenuSizeState === "200px" ? (
                              <span className="report-type">
                                {tGlobal("plans.reminderDistribute.menu")}
                              </span>
                            ) : null}
                          </Link>
                        </div>
                      </div>
                    )}

                    {(projects.paymentGateway || authApi.role === "admin") && (
                      <div className="softpos-container project">
                        <button
                          className={`collapse-button  ${
                            activeGroup === "payment" ? "active-group" : ""
                          } `}
                          onClick={() => changeActiveGroup("payment")}
                        >
                          <span>{t("main.Pay&Inv").toUpperCase()}</span>
                        </button>

                        <div className="SoftPos-Link">
                          <Link
                            to={`/merchant/${merchantId?.merch_id}/paymentGateway/Dashboard`}
                            type={"link"}
                            active={"paymentDashboard"}
                            onclick={changeActiveLink}
                            classname={`link-element   ${
                              active === "paymentDashboard" && `active`
                            }`}
                          >
                            <span className="span-svg">
                              <DashBoardIcon />
                            </span>
                            {mainMenuSizeState === "200px" ? (
                              <span className="report-type">
                                {t("sub.dashboard")}
                              </span>
                            ) : null}
                          </Link>
                          <Link
                            to={`/merchant/${merchantId.merch_id}/paymentGateway/transactions/${handleGetTransactionLink}`}
                            type={"link"}
                            active={"paymentTransactions"}
                            onclick={changeActiveLink}
                            classname={`link-element  ${
                              active === "paymentTransactions" && `active `
                            } `}
                          >
                            <span className="span-svg">
                              <TransactionIcon />
                            </span>
                            {mainMenuSizeState === "200px" ? (
                              <span className="report-type">
                                {t("sub.Transactions")}
                              </span>
                            ) : null}
                          </Link>
                        </div>
                      </div>
                    )}
                    {(projects.invoicing || authApi.role === "admin") && (
                      <div className="softpos-container project">
                        <button
                          className={`collapse-button  ${
                            activeGroup === "Invoice" ? "active-group" : ""
                          } `}
                          onClick={() => changeActiveGroup("Invoice")}
                        >
                          <span> {t("main.invoice").toUpperCase()}</span>
                        </button>

                        <div className="SoftPos-Link">
                          {/*  <Link to={`/Invoice/dashboard`} type={"link"} active={"Invoice-dashboard"} onclick={changeActiveLink} classname={`link-element ${active === "Invoice-dashboard" && `active `}`}>

                                                          <span> <AiOutlineDashboard />   </span> {mainMenuSizeState === '200px' ? <span className="report-type">  DashBoard   </span> : null}
                                                      </Link> */}
                          {(isPayByLinkEnabledForCurrentMerchant ||
                            isRecurringEnabledForCurrentMerchant) && (
                            <Link
                              to={`/merchant/${merchantId.merch_id}/Invoice/createInvoice`}
                              type={"link"}
                              active={"createInvoice"}
                              onclick={changeActiveLink}
                              classname={`link-element ${
                                active === "createInvoice" && `active `
                              } `}
                            >
                              <span className="span-svg">
                                <svg
                                  viewBox="0 0 1024 1024"
                                  className="icon fill"
                                  version="1.1"
                                >
                                  <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                                  <g
                                    id="SVGRepo_tracerCarrier"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  ></g>
                                  <g id="SVGRepo_iconCarrier">
                                    <path d="M731.21 584.34c-100.99 0-182.86 81.87-182.86 182.86 0 100.99 81.87 182.86 182.86 182.86 100.99 0 182.86-81.87 182.86-182.86 0-100.99-81.87-182.86-182.86-182.86z m0 292.57c-60.5 0-109.71-49.22-109.71-109.71 0-60.5 49.22-109.71 109.71-109.71 60.5 0 109.71 49.22 109.71 109.71 0.01 60.49-49.21 109.71-109.71 109.71z"></path>
                                    <path d="M752.9 694.05h-43.89v51.2h-51.2v43.89h51.2v51.2h43.89v-51.2h51.2v-43.89h-51.2zM219.58 474.98h219.43v73.14H219.58z"></path>
                                    <path d="M182.67 365.88H768.3v179.46h73.14V145.21c0-39.96-32.52-72.46-72.48-72.46h-27.34c-29.18 0-55.04 16.71-65.89 42.61-5.68 13.57-27.89 13.55-33.54 0.02-10.84-25.89-36.7-42.62-65.89-42.62h-18.16c-29.18 0-55.04 16.71-65.89 42.61-5.68 13.57-27.89 13.55-33.54 0.02-10.84-25.89-36.7-42.62-65.89-42.62h-17.43c-29.18 0-55.04 16.71-65.89 42.61-5.68 13.57-27.89 13.55-33.54 0.02-10.84-25.89-36.7-42.62-65.89-42.62h-27.59c-39.96 0-72.46 32.5-72.46 72.46v805.14h401.2v-73.14h-328.1l-0.45-511.36z m25.8-222.26c14.29 34.05 47.36 56.05 84.25 56.05 36.91 0 69.98-22.02 82.66-53.79l15.84-2.27c14.29 34.05 47.36 56.05 84.25 56.05 36.91 0 69.98-22.02 82.66-53.79l16.57-2.27c14.29 34.05 47.36 56.05 84.25 56.05 36.91 0 69.98-22.02 82.66-53.79l26.68-0.68V292.7H182.6l-0.13-146.84 26-2.24z"></path>
                                  </g>
                                </svg>
                              </span>
                              {mainMenuSizeState === "200px" ? (
                                <span className="report-type">
                                  {t("sub.createInvoice")}
                                </span>
                              ) : null}
                            </Link>
                          )}

                          <Link
                            to={`/merchant/${merchantId.merch_id}/Invoice/InvoiceList`}
                            type={"link"}
                            active={"InvoiceList"}
                            onclick={changeActiveLink}
                            classname={`link-element  ${
                              active === "InvoiceList" && `active `
                            } `}
                          >
                            <span className="span-svg">
                              <svg
                                width="64px"
                                height="64px"
                                viewBox="0 0 1024 1024"
                                className="icon fill"
                                version="1.1"
                              >
                                <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
                                <g
                                  id="SVGRepo_tracerCarrier"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                ></g>
                                <g id="SVGRepo_iconCarrier">
                                  <path d="M731.15 585.97c-100.99 0-182.86 81.87-182.86 182.86s81.87 182.86 182.86 182.86 182.86-81.87 182.86-182.86-81.87-182.86-182.86-182.86z m0 292.57c-60.5 0-109.71-49.22-109.71-109.71s49.22-109.71 109.71-109.71c60.5 0 109.71 49.22 109.71 109.71s-49.21 109.71-109.71 109.71z"></path>
                                  <path d="M758.58 692.98h-54.86v87.27l69.4 68.79 38.6-38.97-53.14-52.68zM219.51 474.96h219.43v73.14H219.51z"></path>
                                  <path d="M182.61 365.86h585.62v179.48h73.14V145.21c0-39.96-32.5-72.48-72.46-72.48h-27.36c-29.18 0-55.04 16.73-65.88 42.59-5.71 13.64-27.82 13.66-33.57-0.02-10.86-25.86-36.71-42.57-65.88-42.57h-18.16c-29.18 0-55.04 16.73-65.88 42.59-5.71 13.64-27.82 13.66-33.57-0.02-10.86-25.86-36.71-42.57-65.88-42.57H375.3c-29.18 0-55.04 16.73-65.88 42.59-5.71 13.64-27.82 13.66-33.57-0.02-10.86-25.86-36.71-42.57-65.88-42.57H182.4c-39.96 0-72.48 32.52-72.48 72.48v805.14h401.21v-73.14H183.04l-0.43-511.35z m25.81-222.29c14.25 34.09 47.32 56.11 84.23 56.11 36.89 0 69.96-22.02 82.66-53.8l15.86-2.3c14.25 34.09 47.32 56.11 84.23 56.11 36.89 0 69.96-22.02 82.66-53.8l16.59-2.3c14.25 34.09 47.32 56.11 84.23 56.11 36.89 0 69.96-22.02 82.66-53.8l26.68-0.66v147.5H182.54l-0.13-146.84 26.01-2.33z"></path>
                                </g>
                              </svg>
                            </span>
                            {mainMenuSizeState === "200px" ? (
                              <span className="report-type">
                                {t("sub.invoiceList")}
                              </span>
                            ) : null}
                          </Link>
                          <Link
                            to={`/merchant/${merchantId.merch_id}/productManagement`}
                            type={"link"}
                            active={"productManagement"}
                            onclick={changeActiveLink}
                            classname={`link-element  ${
                              active === "productManagement" && `active `
                            } `}
                          >
                            <span className="span-svg">
                              <ProductIcon
                                color={
                                  active === "productManagement"
                                    ? themes.MainGreenColorHexa
                                    : "white"
                                }
                              />
                            </span>
                            {mainMenuSizeState === "200px" ? (
                              <span className="report-type">
                                {t("sub.productList")}
                              </span>
                            ) : null}
                          </Link>
                          <Link
                            to={`/merchant/${merchantId.merch_id}/customers`}
                            type={"link"}
                            active={"Customers"}
                            onclick={changeActiveLink}
                            classname={`link-element ${
                              active === "Customers" && `active `
                            } `}
                          >
                            <span className="span-svg">
                              <CustomersIcon
                                color={
                                  active === "Customers"
                                    ? themes.MainGreenColorHexa
                                    : "white"
                                }
                              />
                            </span>
                            {mainMenuSizeState === "200px" ? (
                              <span className="report-type">
                                {t("sub.customerList")}
                              </span>
                            ) : null}
                          </Link>

                          {/*May be get back --> additional link for users */}
                          {/* {role !== "user" && role !== "supervisor" && (
                            <Link
                              to={`/merchant/${merchantId.merch_id}/users`}
                              type={"link"}
                              active={"users"}
                              onclick={changeActiveLink}
                              classname={`link-element  ${
                                active === "users" && `active `
                              } `}
                            >
                              <span className="span-svg">
                                <FiUsers />
                              </span>
                              {mainMenuSizeState === "200px" ? (
                                <span className="report-type">
                                  {t("sub.users")}
                                </span>
                              ) : null}
                            </Link>
                          )} */}
                        </div>
                      </div>
                    )}

                    {/* Merchant Secret Section for Merchant */}
                    <div className="softpos-container project">
                      <button
                        className={`collapse-button  ${
                          activeGroup === "merchantSecret" ? "active-group" : ""
                        } `}
                        onClick={() => changeActiveGroup("merchantSecret")}
                      >
                        <span>{"Merchant Secret".toUpperCase()}</span>
                      </button>
                      <div className="SoftPos-Link">
                        <Link
                          to={`/merchant/${merchantId.merch_id}/secret`}
                          type={"link"}
                          active={"merchantSecret"}
                          onclick={changeActiveLink}
                          classname={`link-element  ${
                            active === "merchantSecret" && `active `
                          } `}
                        >
                          <span className="span-svg">
                            <PaymentLogo />
                          </span>
                          {mainMenuSizeState === "200px" ? (
                            <span className="report-type">Merchant Secret</span>
                          ) : null}
                        </Link>
                      </div>
                    </div>
                    {projects?.customerSupport && (
                      <div className="softpos-container project">
                        <button
                          className={`collapse-button  ${
                            activeGroup === "contactUs" ? "active-group" : ""
                          } `}
                          onClick={() => changeActiveGroup("contactUs")}
                        >
                          <span>{t("main.contactUs").toUpperCase()}</span>
                        </button>
                        <div className="SoftPos-Link">
                          <Link
                            to={`/tickets`}
                            state={{ layoutType: "partner" }}
                            type={"link"}
                            active={"tickets"}
                            onclick={changeActiveLink}
                            classname={`link-element  ${
                              active === "tickets" && `active `
                            } `}
                          >
                            <span className="span-svg">
                              <object
                                data={HeadSetCustomerService}
                                height="30"
                                color="ffff"
                              ></object>
                            </span>
                            {mainMenuSizeState === "200px" ? (
                              <span className="report-type">
                                {t("sub.tickets")}
                              </span>
                            ) : null}
                          </Link>
                        </div>
                      </div>
                    )}
                  </>
                )}
              </div>
              <div className="collaspe">
                <p className=" link-button" onClick={Logout}>
                  {mainMenuSizeState === "200px" ? (
                    <>
                      <span
                        className="span-svg" /* onClick={() => { setToggleMenuWidth(false); localStorage.setItem('collapse', '90px'); setmainMenuSize(localStorage.getItem('collapse')); }} */
                      >
                        <LogoutIcon />
                      </span>
                      <span className="collapse-span report-type">
                        {t("main.logout")}
                      </span>
                    </>
                  ) : (
                    <>
                      <span
                        className="span-svg" /*  onClick={() => { setToggleMenuWidth(true); localStorage.setItem('collapse', '200px'); setmainMenuSize(localStorage.getItem('collapse')); }} */
                      >
                        <LogoutIcon />
                      </span>
                    </>
                  )}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LeftSideMenu;
